module.exports = __webpack_public_path__ + "media/images/referral-4feeb291f848906c9b6643465af6606c.svg";